import { COGNITO_CLIENT_ID } from '../../constants/cognito';
import { getCognitoDomain, getDomain } from '../../helpers/urls';

const CALLBACK = '/api/auth';

export type SocialLogin = 'Facebook' | 'Google' | 'SignInWithApple';
export function getSocialLoginUrl(platform: SocialLogin): string {
  return `${getCognitoDomain()}/oauth2/authorize?response_type=code&client_id=${COGNITO_CLIENT_ID}&redirect_uri=${getDomain()}${CALLBACK}&identity_provider=${platform}`;
}
